import React from 'react';
import { Card, Typography } from 'antd';
import TransferList from '@/components/transfer/TransferList';

const { Title, Text } = Typography;

const TransfersPage: React.FC = () => {
  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: '24px' }}>
        <Title level={2} style={{ marginBottom: 0 }}>Transfers</Title>
        <Text type="secondary">Transfers in your business unit(s)</Text>
      </div>
      <Card>
        <TransferList />
      </Card>
    </div>
  );
};

export default TransfersPage;
